export const APP_VERSION = "0.1.1";
export const BUILD_TIME = new Date().toISOString();
